import { render, staticRenderFns } from "./ContactGroup.vue?vue&type=template&id=035718b4&"
import script from "./ContactGroup.vue?vue&type=script&lang=js&"
export * from "./ContactGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports